/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DhwPreferences } from './DhwPreferences';
import {
    DhwPreferencesFromJSON,
    DhwPreferencesFromJSONTyped,
    DhwPreferencesToJSON,
    DhwPreferencesToJSONTyped,
} from './DhwPreferences';
import type { Legionella } from './Legionella';
import {
    LegionellaFromJSON,
    LegionellaFromJSONTyped,
    LegionellaToJSON,
    LegionellaToJSONTyped,
} from './Legionella';

/**
 * 
 * @export
 * @interface ConfigSettings
 */
export interface ConfigSettings {
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    airFlowCalibrationCurveType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    airSourceType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    backupHeaterPowerKw?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    bivalentTemperatureCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    chAlternationTimerDurationMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    chRequiredTemperatureDifferenceK?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorFrequencyBlock1Hertz?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorFrequencyBlock2Hertz?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorFrequencyBlock3Hertz?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorFrequencyBlock4Hertz?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorFrequencyBlock5Hertz?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    compressorSpeedMaxRps?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigSettings
     */
    coolingIsAvailable?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    coolingPumpSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    coolingSupplyTemperatureMarginCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    coolingSupplyTemperatureMinCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    degreeMinutesHysteresisCelsiusMinute?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    degreeMinutesStepSizeCelsiusMinute?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    degreeMinutesThresholdCelsiusMinute?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwAlternationTimerDurationMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwBottomSensorHysteresisTemperatureC?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwBottomSensorSetpointTemperatureC?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwCompressorSpeedBoostRps?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwCompressorSpeedHighRps?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwCompressorSpeedLowRps?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    dhwTankType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwTopSensorHysteresisTemperatureC?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    dhwTopSensorSetpointTemperatureC?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    exhaustAirMaximumTemperatureCelsius?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    exhaustAirRestrictionType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    externalModbusType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    externalOutputType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    fanSpeedMaxPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    fanSpeedMinPercentage?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    heatDeliverySystemType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    heatDemandAfterRunTimeMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    heatingCurveHighCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    heatingCurveLowCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    heatingCurveMaxCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    heatingCurveMinCelsius?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    heatingCurveType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigSettings
     */
    isAllElectric?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ConfigSettings
     */
    isExternalOutdoorTemperatureSensorAvailable?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    legionellaTemperatureCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    legionellaTemperatureDurationMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    minimumHeatPumpFlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pumpAfterRunTimeMinutes?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirActiveHeatingSetpointCelsius?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    pureAirDefrostMethod?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirTargetTemperatureCelsius?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirVentilationCurveHighFanSpeedPct?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirVentilationCurveHighFlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirVentilationCurveLowFanSpeedPct?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    pureAirVentilationCurveLowFlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    roomCompensationFactor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    roomDemandHysteresisMinusKelvin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    roomDemandHysteresisPlusKelvin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    supplyTemperatureControllerDeadbandMinusK?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    supplyTemperatureControllerDeadbandPlusK?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    supplyTemperatureMaxCelsius?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    thermostatType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationCurveHighFanSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationCurveHighFlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationCurveLowFanSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationCurveLowFlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel1FanSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel1FlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel2FanSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel2FlowM3PerHour?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel3FanSpeedPercentage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    ventilationLevel3FlowM3PerHour?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    ventilationType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    waterFlowMaxLitersPerMinute?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ConfigSettings
     */
    waterFlowMinLitersPerMinute?: number | null;
    /**
     * 
     * @type {DhwPreferences}
     * @memberof ConfigSettings
     */
    dhwPreferences?: DhwPreferences;
    /**
     * 
     * @type {Legionella}
     * @memberof ConfigSettings
     */
    legionella?: Legionella;
    /**
     * 
     * @type {string}
     * @memberof ConfigSettings
     */
    reportedAt?: string;
}

/**
 * Check if a given object implements the ConfigSettings interface.
 */
export function instanceOfConfigSettings(value: object): value is ConfigSettings {
    return true;
}

export function ConfigSettingsFromJSON(json: any): ConfigSettings {
    return ConfigSettingsFromJSONTyped(json, false);
}

export function ConfigSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'airFlowCalibrationCurveType': json['air_flow_calibration_curve_type'] == null ? undefined : json['air_flow_calibration_curve_type'],
        'airSourceType': json['air_source_type'] == null ? undefined : json['air_source_type'],
        'backupHeaterPowerKw': json['backup_heater_power_kw'] == null ? undefined : json['backup_heater_power_kw'],
        'bivalentTemperatureCelsius': json['bivalent_temperature_celsius'] == null ? undefined : json['bivalent_temperature_celsius'],
        'chAlternationTimerDurationMinutes': json['ch_alternation_timer_duration_minutes'] == null ? undefined : json['ch_alternation_timer_duration_minutes'],
        'chRequiredTemperatureDifferenceK': json['ch_required_temperature_difference_k'] == null ? undefined : json['ch_required_temperature_difference_k'],
        'compressorFrequencyBlock1Hertz': json['compressor_frequency_block1_hertz'] == null ? undefined : json['compressor_frequency_block1_hertz'],
        'compressorFrequencyBlock2Hertz': json['compressor_frequency_block2_hertz'] == null ? undefined : json['compressor_frequency_block2_hertz'],
        'compressorFrequencyBlock3Hertz': json['compressor_frequency_block3_hertz'] == null ? undefined : json['compressor_frequency_block3_hertz'],
        'compressorFrequencyBlock4Hertz': json['compressor_frequency_block4_hertz'] == null ? undefined : json['compressor_frequency_block4_hertz'],
        'compressorFrequencyBlock5Hertz': json['compressor_frequency_block5_hertz'] == null ? undefined : json['compressor_frequency_block5_hertz'],
        'compressorSpeedMaxRps': json['compressor_speed_max_rps'] == null ? undefined : json['compressor_speed_max_rps'],
        'coolingIsAvailable': json['cooling_is_available'] == null ? undefined : json['cooling_is_available'],
        'coolingPumpSpeedPercentage': json['cooling_pump_speed_percentage'] == null ? undefined : json['cooling_pump_speed_percentage'],
        'coolingSupplyTemperatureMarginCelsius': json['cooling_supply_temperature_margin_celsius'] == null ? undefined : json['cooling_supply_temperature_margin_celsius'],
        'coolingSupplyTemperatureMinCelsius': json['cooling_supply_temperature_min_celsius'] == null ? undefined : json['cooling_supply_temperature_min_celsius'],
        'degreeMinutesHysteresisCelsiusMinute': json['degree_minutes_hysteresis_celsius_minute'] == null ? undefined : json['degree_minutes_hysteresis_celsius_minute'],
        'degreeMinutesStepSizeCelsiusMinute': json['degree_minutes_step_size_celsius_minute'] == null ? undefined : json['degree_minutes_step_size_celsius_minute'],
        'degreeMinutesThresholdCelsiusMinute': json['degree_minutes_threshold_celsius_minute'] == null ? undefined : json['degree_minutes_threshold_celsius_minute'],
        'dhwAlternationTimerDurationMinutes': json['dhw_alternation_timer_duration_minutes'] == null ? undefined : json['dhw_alternation_timer_duration_minutes'],
        'dhwBottomSensorHysteresisTemperatureC': json['dhw_bottom_sensor_hysteresis_temperature_c'] == null ? undefined : json['dhw_bottom_sensor_hysteresis_temperature_c'],
        'dhwBottomSensorSetpointTemperatureC': json['dhw_bottom_sensor_setpoint_temperature_c'] == null ? undefined : json['dhw_bottom_sensor_setpoint_temperature_c'],
        'dhwCompressorSpeedBoostRps': json['dhw_compressor_speed_boost_rps'] == null ? undefined : json['dhw_compressor_speed_boost_rps'],
        'dhwCompressorSpeedHighRps': json['dhw_compressor_speed_high_rps'] == null ? undefined : json['dhw_compressor_speed_high_rps'],
        'dhwCompressorSpeedLowRps': json['dhw_compressor_speed_low_rps'] == null ? undefined : json['dhw_compressor_speed_low_rps'],
        'dhwTankType': json['dhw_tank_type'] == null ? undefined : json['dhw_tank_type'],
        'dhwTopSensorHysteresisTemperatureC': json['dhw_top_sensor_hysteresis_temperature_c'] == null ? undefined : json['dhw_top_sensor_hysteresis_temperature_c'],
        'dhwTopSensorSetpointTemperatureC': json['dhw_top_sensor_setpoint_temperature_c'] == null ? undefined : json['dhw_top_sensor_setpoint_temperature_c'],
        'exhaustAirMaximumTemperatureCelsius': json['exhaust_air_maximum_temperature_celsius'] == null ? undefined : json['exhaust_air_maximum_temperature_celsius'],
        'exhaustAirRestrictionType': json['exhaust_air_restriction_type'] == null ? undefined : json['exhaust_air_restriction_type'],
        'externalModbusType': json['external_modbus_type'] == null ? undefined : json['external_modbus_type'],
        'externalOutputType': json['external_output_type'] == null ? undefined : json['external_output_type'],
        'fanSpeedMaxPercentage': json['fan_speed_max_percentage'] == null ? undefined : json['fan_speed_max_percentage'],
        'fanSpeedMinPercentage': json['fan_speed_min_percentage'] == null ? undefined : json['fan_speed_min_percentage'],
        'heatDeliverySystemType': json['heat_delivery_system_type'] == null ? undefined : json['heat_delivery_system_type'],
        'heatDemandAfterRunTimeMinutes': json['heat_demand_after_run_time_minutes'] == null ? undefined : json['heat_demand_after_run_time_minutes'],
        'heatingCurveHighCelsius': json['heating_curve_high_celsius'] == null ? undefined : json['heating_curve_high_celsius'],
        'heatingCurveLowCelsius': json['heating_curve_low_celsius'] == null ? undefined : json['heating_curve_low_celsius'],
        'heatingCurveMaxCelsius': json['heating_curve_max_celsius'] == null ? undefined : json['heating_curve_max_celsius'],
        'heatingCurveMinCelsius': json['heating_curve_min_celsius'] == null ? undefined : json['heating_curve_min_celsius'],
        'heatingCurveType': json['heating_curve_type'] == null ? undefined : json['heating_curve_type'],
        'isAllElectric': json['is_all_electric'] == null ? undefined : json['is_all_electric'],
        'isExternalOutdoorTemperatureSensorAvailable': json['is_external_outdoor_temperature_sensor_available'] == null ? undefined : json['is_external_outdoor_temperature_sensor_available'],
        'legionellaTemperatureCelsius': json['legionella_temperature_celsius'] == null ? undefined : json['legionella_temperature_celsius'],
        'legionellaTemperatureDurationMinutes': json['legionella_temperature_duration_minutes'] == null ? undefined : json['legionella_temperature_duration_minutes'],
        'minimumHeatPumpFlowM3PerHour': json['minimum_heat_pump_flow_m3_per_hour'] == null ? undefined : json['minimum_heat_pump_flow_m3_per_hour'],
        'pumpAfterRunTimeMinutes': json['pump_after_run_time_minutes'] == null ? undefined : json['pump_after_run_time_minutes'],
        'pureAirActiveHeatingSetpointCelsius': json['pure_air_active_heating_setpoint_celsius'] == null ? undefined : json['pure_air_active_heating_setpoint_celsius'],
        'pureAirDefrostMethod': json['pure_air_defrost_method'] == null ? undefined : json['pure_air_defrost_method'],
        'pureAirTargetTemperatureCelsius': json['pure_air_target_temperature_celsius'] == null ? undefined : json['pure_air_target_temperature_celsius'],
        'pureAirVentilationCurveHighFanSpeedPct': json['pure_air_ventilation_curve_high_fan_speed_pct'] == null ? undefined : json['pure_air_ventilation_curve_high_fan_speed_pct'],
        'pureAirVentilationCurveHighFlowM3PerHour': json['pure_air_ventilation_curve_high_flow_m3_per_hour'] == null ? undefined : json['pure_air_ventilation_curve_high_flow_m3_per_hour'],
        'pureAirVentilationCurveLowFanSpeedPct': json['pure_air_ventilation_curve_low_fan_speed_pct'] == null ? undefined : json['pure_air_ventilation_curve_low_fan_speed_pct'],
        'pureAirVentilationCurveLowFlowM3PerHour': json['pure_air_ventilation_curve_low_flow_m3_per_hour'] == null ? undefined : json['pure_air_ventilation_curve_low_flow_m3_per_hour'],
        'roomCompensationFactor': json['room_compensation_factor'] == null ? undefined : json['room_compensation_factor'],
        'roomDemandHysteresisMinusKelvin': json['room_demand_hysteresis_minus_kelvin'] == null ? undefined : json['room_demand_hysteresis_minus_kelvin'],
        'roomDemandHysteresisPlusKelvin': json['room_demand_hysteresis_plus_kelvin'] == null ? undefined : json['room_demand_hysteresis_plus_kelvin'],
        'supplyTemperatureControllerDeadbandMinusK': json['supply_temperature_controller_deadband_minus_k'] == null ? undefined : json['supply_temperature_controller_deadband_minus_k'],
        'supplyTemperatureControllerDeadbandPlusK': json['supply_temperature_controller_deadband_plus_k'] == null ? undefined : json['supply_temperature_controller_deadband_plus_k'],
        'supplyTemperatureMaxCelsius': json['supply_temperature_max_celsius'] == null ? undefined : json['supply_temperature_max_celsius'],
        'thermostatType': json['thermostat_type'] == null ? undefined : json['thermostat_type'],
        'ventilationCurveHighFanSpeedPercentage': json['ventilation_curve_high_fan_speed_percentage'] == null ? undefined : json['ventilation_curve_high_fan_speed_percentage'],
        'ventilationCurveHighFlowM3PerHour': json['ventilation_curve_high_flow_m3_per_hour'] == null ? undefined : json['ventilation_curve_high_flow_m3_per_hour'],
        'ventilationCurveLowFanSpeedPercentage': json['ventilation_curve_low_fan_speed_percentage'] == null ? undefined : json['ventilation_curve_low_fan_speed_percentage'],
        'ventilationCurveLowFlowM3PerHour': json['ventilation_curve_low_flow_m3_per_hour'] == null ? undefined : json['ventilation_curve_low_flow_m3_per_hour'],
        'ventilationLevel1FanSpeedPercentage': json['ventilation_level1_fan_speed_percentage'] == null ? undefined : json['ventilation_level1_fan_speed_percentage'],
        'ventilationLevel1FlowM3PerHour': json['ventilation_level1_flow_m3_per_hour'] == null ? undefined : json['ventilation_level1_flow_m3_per_hour'],
        'ventilationLevel2FanSpeedPercentage': json['ventilation_level2_fan_speed_percentage'] == null ? undefined : json['ventilation_level2_fan_speed_percentage'],
        'ventilationLevel2FlowM3PerHour': json['ventilation_level2_flow_m3_per_hour'] == null ? undefined : json['ventilation_level2_flow_m3_per_hour'],
        'ventilationLevel3FanSpeedPercentage': json['ventilation_level3_fan_speed_percentage'] == null ? undefined : json['ventilation_level3_fan_speed_percentage'],
        'ventilationLevel3FlowM3PerHour': json['ventilation_level3_flow_m3_per_hour'] == null ? undefined : json['ventilation_level3_flow_m3_per_hour'],
        'ventilationType': json['ventilation_type'] == null ? undefined : json['ventilation_type'],
        'waterFlowMaxLitersPerMinute': json['water_flow_max_liters_per_minute'] == null ? undefined : json['water_flow_max_liters_per_minute'],
        'waterFlowMinLitersPerMinute': json['water_flow_min_liters_per_minute'] == null ? undefined : json['water_flow_min_liters_per_minute'],
        'dhwPreferences': json['dhw_preferences'] == null ? undefined : DhwPreferencesFromJSON(json['dhw_preferences']),
        'legionella': json['legionella'] == null ? undefined : LegionellaFromJSON(json['legionella']),
        'reportedAt': json['reported_at'] == null ? undefined : json['reported_at'],
    };
}

export function ConfigSettingsToJSON(json: any): ConfigSettings {
    return ConfigSettingsToJSONTyped(json, false);
}

export function ConfigSettingsToJSONTyped(value?: ConfigSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'air_flow_calibration_curve_type': value['airFlowCalibrationCurveType'],
        'air_source_type': value['airSourceType'],
        'backup_heater_power_kw': value['backupHeaterPowerKw'],
        'bivalent_temperature_celsius': value['bivalentTemperatureCelsius'],
        'ch_alternation_timer_duration_minutes': value['chAlternationTimerDurationMinutes'],
        'ch_required_temperature_difference_k': value['chRequiredTemperatureDifferenceK'],
        'compressor_frequency_block1_hertz': value['compressorFrequencyBlock1Hertz'],
        'compressor_frequency_block2_hertz': value['compressorFrequencyBlock2Hertz'],
        'compressor_frequency_block3_hertz': value['compressorFrequencyBlock3Hertz'],
        'compressor_frequency_block4_hertz': value['compressorFrequencyBlock4Hertz'],
        'compressor_frequency_block5_hertz': value['compressorFrequencyBlock5Hertz'],
        'compressor_speed_max_rps': value['compressorSpeedMaxRps'],
        'cooling_is_available': value['coolingIsAvailable'],
        'cooling_pump_speed_percentage': value['coolingPumpSpeedPercentage'],
        'cooling_supply_temperature_margin_celsius': value['coolingSupplyTemperatureMarginCelsius'],
        'cooling_supply_temperature_min_celsius': value['coolingSupplyTemperatureMinCelsius'],
        'degree_minutes_hysteresis_celsius_minute': value['degreeMinutesHysteresisCelsiusMinute'],
        'degree_minutes_step_size_celsius_minute': value['degreeMinutesStepSizeCelsiusMinute'],
        'degree_minutes_threshold_celsius_minute': value['degreeMinutesThresholdCelsiusMinute'],
        'dhw_alternation_timer_duration_minutes': value['dhwAlternationTimerDurationMinutes'],
        'dhw_bottom_sensor_hysteresis_temperature_c': value['dhwBottomSensorHysteresisTemperatureC'],
        'dhw_bottom_sensor_setpoint_temperature_c': value['dhwBottomSensorSetpointTemperatureC'],
        'dhw_compressor_speed_boost_rps': value['dhwCompressorSpeedBoostRps'],
        'dhw_compressor_speed_high_rps': value['dhwCompressorSpeedHighRps'],
        'dhw_compressor_speed_low_rps': value['dhwCompressorSpeedLowRps'],
        'dhw_tank_type': value['dhwTankType'],
        'dhw_top_sensor_hysteresis_temperature_c': value['dhwTopSensorHysteresisTemperatureC'],
        'dhw_top_sensor_setpoint_temperature_c': value['dhwTopSensorSetpointTemperatureC'],
        'exhaust_air_maximum_temperature_celsius': value['exhaustAirMaximumTemperatureCelsius'],
        'exhaust_air_restriction_type': value['exhaustAirRestrictionType'],
        'external_modbus_type': value['externalModbusType'],
        'external_output_type': value['externalOutputType'],
        'fan_speed_max_percentage': value['fanSpeedMaxPercentage'],
        'fan_speed_min_percentage': value['fanSpeedMinPercentage'],
        'heat_delivery_system_type': value['heatDeliverySystemType'],
        'heat_demand_after_run_time_minutes': value['heatDemandAfterRunTimeMinutes'],
        'heating_curve_high_celsius': value['heatingCurveHighCelsius'],
        'heating_curve_low_celsius': value['heatingCurveLowCelsius'],
        'heating_curve_max_celsius': value['heatingCurveMaxCelsius'],
        'heating_curve_min_celsius': value['heatingCurveMinCelsius'],
        'heating_curve_type': value['heatingCurveType'],
        'is_all_electric': value['isAllElectric'],
        'is_external_outdoor_temperature_sensor_available': value['isExternalOutdoorTemperatureSensorAvailable'],
        'legionella_temperature_celsius': value['legionellaTemperatureCelsius'],
        'legionella_temperature_duration_minutes': value['legionellaTemperatureDurationMinutes'],
        'minimum_heat_pump_flow_m3_per_hour': value['minimumHeatPumpFlowM3PerHour'],
        'pump_after_run_time_minutes': value['pumpAfterRunTimeMinutes'],
        'pure_air_active_heating_setpoint_celsius': value['pureAirActiveHeatingSetpointCelsius'],
        'pure_air_defrost_method': value['pureAirDefrostMethod'],
        'pure_air_target_temperature_celsius': value['pureAirTargetTemperatureCelsius'],
        'pure_air_ventilation_curve_high_fan_speed_pct': value['pureAirVentilationCurveHighFanSpeedPct'],
        'pure_air_ventilation_curve_high_flow_m3_per_hour': value['pureAirVentilationCurveHighFlowM3PerHour'],
        'pure_air_ventilation_curve_low_fan_speed_pct': value['pureAirVentilationCurveLowFanSpeedPct'],
        'pure_air_ventilation_curve_low_flow_m3_per_hour': value['pureAirVentilationCurveLowFlowM3PerHour'],
        'room_compensation_factor': value['roomCompensationFactor'],
        'room_demand_hysteresis_minus_kelvin': value['roomDemandHysteresisMinusKelvin'],
        'room_demand_hysteresis_plus_kelvin': value['roomDemandHysteresisPlusKelvin'],
        'supply_temperature_controller_deadband_minus_k': value['supplyTemperatureControllerDeadbandMinusK'],
        'supply_temperature_controller_deadband_plus_k': value['supplyTemperatureControllerDeadbandPlusK'],
        'supply_temperature_max_celsius': value['supplyTemperatureMaxCelsius'],
        'thermostat_type': value['thermostatType'],
        'ventilation_curve_high_fan_speed_percentage': value['ventilationCurveHighFanSpeedPercentage'],
        'ventilation_curve_high_flow_m3_per_hour': value['ventilationCurveHighFlowM3PerHour'],
        'ventilation_curve_low_fan_speed_percentage': value['ventilationCurveLowFanSpeedPercentage'],
        'ventilation_curve_low_flow_m3_per_hour': value['ventilationCurveLowFlowM3PerHour'],
        'ventilation_level1_fan_speed_percentage': value['ventilationLevel1FanSpeedPercentage'],
        'ventilation_level1_flow_m3_per_hour': value['ventilationLevel1FlowM3PerHour'],
        'ventilation_level2_fan_speed_percentage': value['ventilationLevel2FanSpeedPercentage'],
        'ventilation_level2_flow_m3_per_hour': value['ventilationLevel2FlowM3PerHour'],
        'ventilation_level3_fan_speed_percentage': value['ventilationLevel3FanSpeedPercentage'],
        'ventilation_level3_flow_m3_per_hour': value['ventilationLevel3FlowM3PerHour'],
        'ventilation_type': value['ventilationType'],
        'water_flow_max_liters_per_minute': value['waterFlowMaxLitersPerMinute'],
        'water_flow_min_liters_per_minute': value['waterFlowMinLitersPerMinute'],
        'dhw_preferences': DhwPreferencesToJSON(value['dhwPreferences']),
        'legionella': LegionellaToJSON(value['legionella']),
        'reported_at': value['reportedAt'],
    };
}

